import { Component } from '@angular/core';

@Component({
  selector: 'app-docs',
  imports: [],
  templateUrl: './docs.component.html',
  styleUrl: './docs.component.css'
})
export class DocsComponent {

}
